// Turbo Drive on auth pages — cached assets, no full reload between login / password / signup.
import "@hotwired/turbo-rails"
import "./segmetrics_identity"

function markFastAuthPageReady(body) {
  if (!body || body.dataset.authFast !== "true") return
  body.classList.add("auth-page-ready")
  body.classList.remove("auth-submitting")
  const loader = body.querySelector(".auth-loader")
  if (loader) loader.classList.add("auth-loader--hidden")
}

// In-app navigation only — do not run on full reload (turbo:load), or loader/CSS race shows bare HTML.
document.addEventListener("turbo:before-render", (event) => {
  markFastAuthPageReady(event.detail?.newBody)
})

function sanitizedAnalyticsLocation() {
  const url = new URL(window.location.href)
  ;["token", "access_token", "code", "hmac", "handoff"].forEach((key) => {
    url.searchParams.delete(key)
  })
  return url
}

// Page views on Turbo navigations (login ↔ forgot-password, etc.) for GTM / gtag.
document.addEventListener("turbo:load", () => {
  const liveUrl = new URL(window.location.href)
  if (liveUrl.hash || [...liveUrl.searchParams.keys()].some(key => /^(?:token|access_token|refresh_token|id_token|reset_password_token|confirmation_token|unlock_token|authenticity_token|password|password_confirmation|secret|client_secret|email|code|hmac|handoff)$/i.test(key))) return
  const url = sanitizedAnalyticsLocation()
  const pageLocation = url.toString()
  const pagePath = url.pathname + url.search

  if (window.dataLayer) {
    window.dataLayer.push({
      event: "page_view",
      page_path: pagePath,
      page_location: pageLocation,
      page_title: document.title,
    })
  }

  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: pagePath,
      page_location: pageLocation,
      page_title: document.title,
    })
  }
})
